import { translate as tr, getLocale } from './index';

// Display only: never use these formatted values as IDs, API values or date keys.
export function formatDate(value, options = {}) {
  if (!value) return '—';
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? '—' : new Intl.DateTimeFormat(getLocale(), options).format(date);
}
export function formatNumber(value, options = {}) {
  return new Intl.NumberFormat(getLocale(), options).format(value);
}
export function relativeTime(value) {
  const seconds = (new Date(value).getTime() - Date.now()) / 1000;
  if (!Number.isFinite(seconds)) return '—';
  const [divisor, unit] = Math.abs(seconds) < 60 ? [1, 'second'] : Math.abs(seconds) < 3600 ? [60, 'minute'] : Math.abs(seconds) < 86400 ? [3600, 'hour'] : [86400, 'day'];
  return new Intl.RelativeTimeFormat(getLocale(), { numeric: 'auto' }).format(Math.round(seconds / divisor), unit);
}

export function formatInvoiceStatus(status) {
  const labels = {"DRAFT": "Draft", "ISSUED": "Issued", "PARTIALLY_PAID": "Partially Paid", "PAID": "Paid", "OVERDUE": "Overdue", "VOID": "Void", "SENT": "Sent", "PENDING": "Pending", "FAILED": "Failed", "MANUAL": "Manual", "AUTOMATIC": "Automatic", "OTHER": "Other"};
  return tr(labels[status] || String(status || "DRAFT").replace(/_/g, " "));
}
